import CustomBarComponent from "./CustomBarComponent";
import React, { useMemo } from "react";
import useWindowSize from "hooks/windowSize";
import { ResponsiveBar } from "@nivo/bar";

import { Absolute, Content } from "./styles";

type ChartProps = {
  data: any[];
};

const Chart = ({ data }: ChartProps): JSX.Element => {
  const [width] = useWindowSize();

  const minHeight = useMemo((): number => {
    const length = data?.length;

    switch (length) {
      case 1:
        return 50;
      case 2:
        return 120;
      default:
        return 120 + (length - 2) * 40;
    }
  }, [data]);

  return (
    <Content minHeight={minHeight}>
      <Absolute>
        <ResponsiveBar
          data={data}
          keys={["monthValue"]}
          barComponent={CustomBarComponent}
          indexBy="month"
          layout="horizontal"
          valueFormat={(value) => value.toFixed(3).replace(".", ",")}
          margin={{
            top: 20,
            right: width <= 768 ? 50 : 70,
            bottom: 20,
            left: 70,
          }}
          padding={0}
          valueScale={{ type: "linear" }}
          animate={false}
          enableGridY={false}
          isInteractive={false}
          axisTop={null}
          axisRight={null}
          axisBottom={null}
          axisLeft={null}
        />
      </Absolute>
    </Content>
  );
};

export default Chart;
